import React from 'react';
import classes from './HandlingUserData.module.css';

const hu = (props) => (
  <div className={classes.Content}>
    {props.indexPage
      ? <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}><b>Adatok letöltése</b></p>
        <p>Az adatok letöltéséhez látogasson el a következő oldalra<br />
          Beállítások > Opciók > Adatkezelés > Adatok letöltése
        </p><br />
        <div className={classes.HrLine} />
        <br />
      </div>
      : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}><b>Adattörlés kérése</b></p><br />
    <p>Az adatok törlésének kéréséhez kövesse az alábbi lépéseket:</p><br />
    <p>Menjen a Kapcsolat oldalra <br />
      Válassza a "Fiók és az összes adatom törlése" lehetőséget. <br />
      Nyomja meg a Küldés gombot <br /><br />
    </p>
    <p>CS csapatunk 24 órán belül törli az összes adatot.</p>
  </div>
);

export default hu;



// WEBPACK FOOTER //
// ./src/assets/localization/hud/hu.js